/* global axios */
import ApiClient from './ApiClient';

class WhatsappCatalogAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getCatalogs(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_catalogs`);
  }

  getProducts(inboxId, { catalogId, q, after } = {}) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_catalog_products`, {
      params: { catalog_id: catalogId, q, after },
    });
  }

  syncCatalog(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_whatsapp_catalog`);
  }

  createCatalog(inboxId, name, businessId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_catalogs`, {
      name,
      business_id: businessId,
    });
  }

  connectCatalog(inboxId, catalogId) {
    return axios.post(`${this.url}/${inboxId}/connect_whatsapp_catalog`, {
      catalog_id: catalogId,
    });
  }

  createProduct(inboxId, catalogId, product) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_catalog_products`, {
      catalog_id: catalogId,
      product,
    });
  }
}

export default new WhatsappCatalogAPI();
